import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Observable } from 'rxjs';
import { UserTableComponent } from 'src/app/components/tables/user/user-table.component';
import { Clinic } from 'src/app/models/clinic.model';
import { User } from 'src/app/models/user.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';

@Component({
  selector: 'clinic-users',
  standalone: true,
  imports: [BreadcrumbModule, AsyncPipe, UserTableComponent],
  templateUrl: './users.component.html',
})
export class ClinicUsersComponent {
  appName: string = localStorage.getItem('appName');
  appId: string = localStorage.getItem('appId');
  clinic: Clinic;

  users$: Observable<User[]>;
  home: MenuItem;
  breadcrumbItems: MenuItem[] = [];

  private clinicService = inject(ClinicService);
  private sidebarMenuService = inject(SideBarMenuService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.clinic = this.route.snapshot.data['clinic'];
    this.home = {
      icon: 'pi pi-fw pi-mobile',
      routerLink: '/',
      command: () => this.sidebarMenuService.clearSessionStorage(),
    };
    this.breadcrumbItems = [
      { label: this.appName },
      { label: 'Clínicas', routerLink: '/clinics' },
      { label: this.clinic.name },
      { label: 'Usuarios', styleClass: 'font-bold' },
    ];
    this.users$ = this.clinicService.findUsers(this.clinic.id);
  }
}
